import React from 'react';
import styled from 'styled-components';

import GalleryOverlay from './GalleryOverlay';
import PatternRepeat from './PatternRepeat';
import PatternImage from '../image/Pattern';

const Media = styled.div`
    overflow: hidden;
    position: relative;
    width: 100%;
    max-height: 80vh;

    & img {
      height: 100%;
      width: 100%;
    }

    &:last-child {
      padding-bottom: 0px;
    }
`;

const Pattern = ({ imgUri, overlay, overlayPath }) => (
    <Media>
        <GalleryOverlay overlay={overlay} path={overlayPath} >
            <PatternRepeat item={<PatternImage src={imgUri} />} />
        </GalleryOverlay>
    </Media>
);


export default Pattern;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternCardPattern.js